export enum NumberType {
  price = 'PRICE',
  percentage = 'PERCENTAGE',
  quantity = 'QUANTITY'
}
